<template>
  <div class="molecule-contract text-size-12" @click="clickItem">
    <b-card>
      <div class="row">
        <div class="col-12 col-lg-3">
          <div class="d-flex align-items-center">
            <span class="text-weight-semibold text-size-16">
              {{ `${contractIdLabel}: ${data.id}` }}
            </span>
            <b-badge
              pill
              :variant="badgeVariant(data.status.id)"
              class="badge--width text-size-12 ml-2"
            >
              {{ badgeStatus(data.status.id) }}
            </b-badge>
          </div>
          <div class="mt-1">
            <div class="text-size-14 text-weight-medium">
              {{ data.customer.organizationName || "-" }}
            </div>
            <div class="text-regular-grey">
              {{ data.customer.customerName || "-" }}
            </div>
            <div class="mt-1">
              <label>Site:</label>
              <b-badge
                variant="light-dark"
                class="badge--width text-size-12 ml-1"
              >
                {{ data.site || "Site Not Found" }}
              </b-badge>
            </div>
          </div>
          <hr v-if="hasAdditionalId" />
          <div v-if="hasAdditionalId" class="row">
            <div class="col-12 custom-margin-bottom-8">
              <span class="text-title">Additional ID</span>
            </div>
            <div
              v-for="(additionalId, index) in data.additionalIds"
              :key="index"
              class="col-12"
            >
              <li class="addition-id-list ml-1">{{ additionalId }}</li>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mt-2 mt-lg-0">
          <div class="text-title mb-1">Service / Packages / Location</div>
          <div class="scrollable">
            <div
              v-for="(packages, index) in data.package"
              :key="index"
              class="molecule-contract__service mb-1"
            >
              <div class="text-size-14 text-weight-medium">
                {{ packages.service }}
              </div>
              <div class="text-regular-grey">
                {{ packages.packageName }} ({{ packages.locationName }} )
              </div>
              <div class="row">
                <div class="col-12 col-md-12 col-lg-4 mt-1 mt-lg-0">
                  <div class="text-title my-1 mb-0">Domain</div>
                  <div v-if="!!packages.domain && !!packages.domain.length">
                    <li class="pl-1 word-break">
                      {{ packages.domain || "-" }}
                    </li>
                  </div>
                  <div v-else>
                    <span class="pl-1">-</span>
                  </div>
                </div>
                <div class="col-12 col-md-12 col-lg-8 mt-1 mt-lg-0">
                  <div class="text-title my-1 mb-0">Racks</div>
                  <div v-if="!!packages.rack && !!packages.rack.length">
                    <div class="row pl-1">
                      <li
                        class="col-12 word-break rack-list"
                        v-for="(rack, index) in packages.rack"
                        :key="index"
                      >
                        <div class="rack-name">{{ rack.name }}</div>
                        <div v-if="rack.description">{{ rack.description }}</div>
                        <div>
                          Location:
                          {{
                            `${rack.building.name} ${rack.floor.name} ${rack.room.name}`
                          }}
                        </div>
                      </li>
                    </div>
                  </div>
                  <div v-else>
                    <span class="pl-1">-</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 mt-2 mt-lg-0">
          <div class="text-title mb-1">Sale / NTDC Contact</div>
          <div>
            <div class="text-size-14 text-weight-medium">
              {{ data.saleContact.name }}
            </div>
            <div class="text-weight-light">
              {{ data.saleContact.phone.toString() }}
            </div>
            <div class="text-weight-light">
              {{ data.saleContact.email.toString() }}
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard, BBadge } from "bootstrap-vue"
import mixins from "@/mixins"

export default {
  name: "MoleculeContractItem",
  components: { BCard, BBadge },
  mixins: [mixins],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  emits: ["click"],
  computed: {
    hasAdditionalId() {
      return !!this.data.additionalIds?.length
    },
  },
  methods: {
    badgeVariant(status) {
      if (status === 1) return "light-success"
      if (status === 2) return "light-danger"
      if (status === 3) return "light-info"
      if (status === 4) return "light-secondary"
      return "light-warning"
    },
    badgeStatus(status) {
      if (status === 1) return "Approved"
      if (status === 2) return "Deleted"
      if (status === 3) return "Pending"
      if (status === 4) return "Expired"
      return "Suspended"
    },
    clickItem() {
      this.$emit("click", this.data)
    },
  },
}
</script>

<style lang="scss" scoped>
.molecule-contract .card {
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important;

  &:hover {
    background-color: #f6f6f9;
    cursor: pointer;
  }
}

.text-title {
  color: #b9b9c3;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 500;
}

.molecule-contract__sale {
  padding-left: 100px;
}

.molecule-contract__service {
  border-radius: 6px;
  background: #f8f8f8;
  padding: 10px;
}

.word-break {
  word-break: break-all;
}

.rack-list {
  margin-bottom: 0.5rem;
}

.rack-name {
  font-weight: 500;
}

.scrollable {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 25vh;
}

.contract-additional-id-container {
  border: 1px dashed rgba(115, 103, 240, 0.4);
}

@media (min-width: 992px) {
  .addition-id-list {
    text-wrap: nowrap;
  }
}
</style>
